import { usePreferences } from "../../../../contexts/PreferencesContext";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { logout } from "../../../../actions/AppActions";
import { CircularProgress } from "@material-ui/core";
import Request from "../../../../Request";
import TableEmptyState from '../../../ReusableComponents/TableEmptyState';


const SalasOnline = (props) => {const { t } = usePreferences();
  const [loading, setLoading] = useState(true);
  const [processo, setProcesso] = useState({});
  const dispatch = useDispatch();

  const get_processo = useCallback(async (processo_id) => {
    setLoading(true);
    let response = await Request.Get(`faculdade/dashboard/processo/salas/${processo_id}`);
    console.log(response);
    if (response === undefined) return;
    if (response['message'] == 'Unauthenticated.') {
      dispatch(logout());
      return;
    }
    setProcesso(response.processo);
    setLoading(false);
    return response;
  }, [props.processo_id]);

  useEffect(() => {
    get_processo(props.processo.id);
  }, []);
  console.log(props.processo);
  return (
    <>
        {loading == false &&
      <>
            <p><b>{t("ui_candidatos_online_por_sala_c4a7fb6b")}</b></p>

        <div className="table-modern-card">
                <div className="table-modern-scroll mb-0">
                    <table id="tech-companies-1" className="table table-striped">
                        <thead>
                            <tr>

                                <th>{t("legacy_sala")}</th>
                                <th>{t("legacy_n_candidatos")}</th>
                                <th>{t("ui_candidatos_online_fe6d8bc6")}</th>

                            </tr>
                        </thead>
                        <tbody>
                            {processo.salas.map((item, id) =>

                <tr key={id}>
                                    <td>{`${t("legacy_sala")} `}{item.numero}</td>
                                    <td>{item.total}</td>
                                    <td>{item.online}</td>



                                </tr>
                )}

                        </tbody>
                    </table>

                </div>
            </div>
            {processo.salas.length == 0 && <div className="row">
                <div className="col-12">
                    <TableEmptyState title={t("empty_no_room_found")} icon="📋" />

                </div>
            </div>}

            <p><b>Avaliadores Online:</b></p>
            <div className="table-modern-card">
                <div className="table-modern-scroll mb-0">
                    <table id="tech-companies-1" className="table table-striped">
                        <thead>
                            <tr>

                                <th>Npme</th>
                                <th>{t("label_email")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.processo?.avaliadores_online?.map((item, id) =>

                <tr key={id}>
                                    <td>{item.name}</td>
                                    <td>{item.email}</td>
                                </tr>
                )}

                        </tbody>
                    </table>

                </div>
            </div>
            {props.processo.avaliadores_online.length == 0 && <div className="row">
                <div className="col-12">
                    <TableEmptyState title={t("ui_nenhum_avaliador_online_vinculado_a_este_cargo_85e7dc18")} icon="📋" />

                </div>
            </div>}
        </>}
        {loading == true && <div className="row" style={{ margin: 0 }}> <div className="col-12 d-flex justify-content-center align-items-center">
                <CircularProgress />
            </div></div>}

        </>);



};

export default SalasOnline;